import { customElement } from "lit/decorators.js";
import { CommunityFormPage } from "./community-form-page";
import { translate } from "../../translations/i18n";

@customElement("edit-community-page")
export class EditCommunityPage extends CommunityFormPage {
  get mode() {
    return "edit" as const;
  }

  get pageTitle() {
    return translate("communitiesPage.editPageTitle");
  }

  override connectedCallback(): void {
    super.connectedCallback();
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const editIndex = pathSegments.indexOf("edit");
    const communityId = editIndex !== -1 ? pathSegments[editIndex + 1] : undefined;
    if (communityId) {
      this.authState.ready.then(() => {
        this.formService.loadCommunity(communityId);
        this.formService.loadAvailableEvents();
      });
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "edit-community-page": EditCommunityPage;
  }
}
